import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const eligibilitiesSchema: CollectionCreateSchema = {
  name: CollectionName.Eligibilities,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      infix: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
